import React                        from 'react';
import { UTC, utc }                 from 'rewire-common';
import { Observe }                  from 'rewire-core';
import { IFieldDefn, IFormContext } from 'rewire-ui';
import { utcDateToLocalDate }       from '../utility/DateUtils';
import { Theme }                    from '@material-ui/core/styles';
import { makeStyles }               from '../utility/styles';
import { PickerToolbar, ToolbarButton } from './materialPickerInterop';

const toolbarStyles = (_theme: Theme) => ({
	toolbar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    height: '115px',
    padding: '10px 20px',
  },
  buttonContainerDefault: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  buttonContainerCustom: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
  },
});

const useToolbarStyles = makeStyles(toolbarStyles);

const CustomDatePickerToolbarFn = (getEarnedDate: () => UTC) => (props: any) => {

	const { date, isLandscape, openView, setOpenView, title, onChange } = props;

	const handleChangeViewClick = (view: 'date' | 'year') => (_evt: React.MouseEvent<any>) => {
		setOpenView(view);
  };

  const handleEarnedDateClick = () => (_evt: React.MouseEvent<any>) => {
    const newDateValue = getEarnedDate().toUTCDate();
    onChange(newDateValue);
  };

  const classes   = useToolbarStyles();
  const year      = date.getUTCFullYear();
  const yearLabel = `${year}`;
  const dateLabel = date.toLocaleDateString('en-us', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });

	return (
    <PickerToolbar className={classes.toolbar} title={title} isLandscape={isLandscape}>
      <div className={classes.buttonContainerDefault}>
        <ToolbarButton
          onClick={handleChangeViewClick('year')}
          variant='h6'
          label={yearLabel}
          selected={openView === 'year'}
        />
        <ToolbarButton
          onClick={handleChangeViewClick('date')}
          variant='h4'
          selected={openView === 'date'}
          label={dateLabel}
        />
      </div>
      <Observe render={() => (
        <div className={classes.buttonContainerCustom}>
          <ToolbarButton
            onClick={handleEarnedDateClick()}
            variant='body2'
            label={'Shift Earned Date'}
            selected={getEarnedDate().equals(utc(utcDateToLocalDate(date)))}
          />
        </div>
      )} />
    </PickerToolbar>
	);
};

export const getCustomFormDatePickerFn = (getEarnedDate: () => UTC) => (form: IFormContext, editProps?: any): IFieldDefn => {
  const dateOptions = {
    ToolbarComponent: CustomDatePickerToolbarFn(getEarnedDate),
    ...editProps,
  };
  return form.date(dateOptions);
};
